/**
 * @class service_v3sPrintService
 * @memberOf v3sWbtPlayerApp:helper
 *
 */

angular.module('v3sWbtPlayerApp').factory('v3sPrintService', ["v3sLog", "v3sI18nService", "v3sBrowserInfoService", "$timeout", function (v3sLog, v3sI18nService, v3sBrowserInfoService, $timeout) {
    /**
     * Erstellt einen "Screenshot" von v3s-document
     * @memberOf v3sWbtPlayerApp:helper.service_v3sPrintService
     * @param {object} element - das Element
     * @param {string} format - das Format des Screenshots
     */
    function createDataUrl(element, format){
        //v3s-document als angular.element
        var v3sdocument = angular.element(element.querySelector("v3s-document"));
        var v3spageviewStyles = window.getComputedStyle(v3sdocument.parent()[0]);

        //Die Höhe und Breite von v3s-document
        var borderWidth = (v3spageviewStyles.borderLeftWidth != "") ? parseInt(v3spageviewStyles.borderLeftWidth) * 2 : 0;
        var documentHeight = parseInt(v3sdocument[0].offsetHeight) + borderWidth;
        var documentWidth = parseInt(v3sdocument[0].offsetWidth) + borderWidth;

        //Die Höhe des A4 Drucks
        var a4Height = 0;


        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        if (format == "A4") {
            a4Height = documentWidth * 1.41;
        }

        canvas.width = documentWidth;
        canvas.height = (format != "A4") ? documentHeight : a4Height;

        if(format != "A4"){
            ctx.fillStyle = v3spageviewStyles.backgroundColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        } else {
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }


        var tagname, cssStyles, imgEl, child, childTop, childLeft, lineHeight, fontSize;
        var children = v3sdocument.children();

        for(var i = 0; i < children.length; i++){
            //Attribute und Go
            child = children[i];

            //Bei der A4 Ansicht sollen Elemente innerhalb der Dokumenthöhe ignoriert werden
            if (format == "A4" && child.getAttribute("v3s-top") < documentHeight) continue;



            childTop = (format == "A4") ? child.offsetTop - documentHeight : child.offsetTop;

            if (child.tagName.toLowerCase() == "v3s-group") {
                angular.forEach(angular.element(child).children(), function (grpChild) {
                    drawElementOnCanvas(grpChild, ctx, childTop, true, format);
                })
            } else {
                drawElementOnCanvas(child, ctx, childTop, false, format);
            }
            ctx.restore();
        }



        v3sdocument.append(canvas);
        var data = {};
        if (canvas.msToBlob) {
            data.blob = canvas.msToBlob();
        }

        try{
            data.dataUrl = canvas.toDataURL();
        } catch (e) {
            data.error = e;
            v3sLog.error(v3sI18nService.getText("general.printfailed"),e.message);
        }

        v3sdocument[0].removeChild(canvas);

        return data;
    }


    function drawElementOnCanvas(child, ctx, childTop, isInGroup, format) {
        var tagname, cssStyles, imgEl, childLeft, lineHeight, fontSize;
        //Wenn es nicht sichtbar ist, brauchen wir es nicht zeichnen
        if (!child.offsetParent) return;

        if (isInGroup) {
            childTop = childTop + child.offsetTop;

        }

        tagname = child.tagName.toLowerCase();
        if (tagname == "v3s-graphic") {
            imgEl = child.querySelector("img");
            childLeft = child.offsetParent.offsetLeft + child.offsetLeft;
            ctx.drawImage(imgEl, childLeft,childTop);
        } else if (tagname == "v3s-text") {
            writeTextOnCanvas(child, ctx, format, childTop, isInGroup);
        }
    }

    function writeTextOnCanvas(txtEl, ctx, format, childTop, isInGroup) {
        var cssStyles,
            lineHeight,
            fontSize,
            txtElOffsetTop,
            wordOffsetTop,
            txtElOffsetLeft,
            wordOffsetLeft;

        //v3s-document als angular.element
        var v3sdocument = angular.element(document.querySelector("v3s-document"));
        var v3spageviewStyles = window.getComputedStyle(v3sdocument.parent()[0]);


        //Offsetparent ist bei Elementen in einer Gruppe v3s-group
        var offsetParent = isInGroup ? txtEl.offsetParent : txtEl;
        var groupOffsetTop = isInGroup ? txtEl.offsetParent.offsetTop : 0;
        var groupOffsetLeft = isInGroup ? txtEl.offsetParent.offsetLeft : 0;

        //Die Höhe und Breite von v3s-document
        var borderWidth = (v3spageviewStyles.borderLeftWidth != "") ? parseInt(v3spageviewStyles.borderLeftWidth) * 2 : 0;
        var documentHeight = parseInt(v3sdocument[0].offsetHeight) + borderWidth;
        if (format == "A4") {
            txtEl.classList.add("v3s-print-text");
        }

        /**
         * Damit alle Textformatierungen angezeigt werdern, müssen alle Kindelement einzeln
         * gezeichnet werden
        **/
        var maxLineheight = 0
        var children = angular.element(txtEl.querySelector("v3s-data")).children();

        //Wenn bei den Kindelementen ein Listitem ist,
        //Muss das list-style-image gemalt werden

        angular.forEach(children, function (child, $index) {
            if (child.tagName.toLowerCase() == "v3s-listitem") {
                txtElOffsetTop = txtEl.offsetTop;
                txtElOffsetLeft = txtEl.offsetLeft;
                lineHeight = parseInt(window.getComputedStyle(txtEl).lineHeight);
                var beforeCssStyles = window.getComputedStyle(child, ":before");
                var listItemWidth = parseInt(beforeCssStyles.width);
                var listItemFontSize = parseInt(beforeCssStyles.fontSize);
                var offsetParentTop = txtElOffsetTop;
                //Bei A4 Format müssen wir die Elemente "nach oben ziehen" indem wir die documentHöhe abziehen
                if (format == "A4") {
                    offsetParentTop -= documentHeight
                }

                //Das Listitemzeichen soll immer vor dem Ersten Char erscheinen.

                var splittexttogetfirstchar = new SplitText(child, { type: "chars, words" });
                var firstChar = splittexttogetfirstchar.chars[0];
                var firstWord = firstChar.offsetParent;

                var y = groupOffsetTop + offsetParentTop + child.offsetTop + (lineHeight / 2);
                var x = groupOffsetLeft + txtElOffsetLeft + child.offsetLeft + firstWord.offsetLeft + firstChar.offsetLeft - listItemWidth / 2;
                var r = listItemFontSize / 2;
                ctx.beginPath();
                ctx.fillStyle = beforeCssStyles.color;
                ctx.strokeStyle = beforeCssStyles.color;
                ctx.arc(x, y, r, 0, 2 * Math.PI);
                ctx.fill();
                ctx.stroke();
                splittexttogetfirstchar.revert();
            }
        });
        var split = new SplitText(txtEl.querySelector("v3s-data"), { type: "chars, words" });

        split.chars.forEach(function (child, $index) {
            cssStyles = window.getComputedStyle(child);
            lineHeight = parseInt(cssStyles.lineHeight);
            maxLineheight = (lineHeight > maxLineheight) ? lineHeight : maxLineheight;
            fontSize = parseInt(cssStyles.fontSize);

            txtElOffsetTop = child.offsetParent.offsetParent.offsetTop;
            wordOffsetTop = child.offsetParent.offsetTop;

            txtElOffsetLeft = child.offsetParent.offsetParent.offsetLeft;
            wordOffsetLeft = child.offsetParent.offsetLeft;

            offsetParentTop = txtElOffsetTop + wordOffsetTop;
            //Bei A4 Format müssen wir die Elemente "nach oben ziehen" indem wir die documentHöhe abziehen
            if (format == "A4") {
                offsetParentTop -= documentHeight
            }
            childTop = groupOffsetTop + offsetParentTop + child.offsetTop;
            childLeft = groupOffsetLeft + txtElOffsetLeft + wordOffsetLeft + child.offsetLeft;
            ctx.textAlign = "left";
            ctx.textBaseline = "top";
            ctx.fillStyle = cssStyles.color;
            ctx.font = cssStyles.fontStyle + " normal " + cssStyles.fontWeight + " " + cssStyles.fontSize + " " + cssStyles.fontFamily;
            ctx.fillText(child.innerText, childLeft, childTop, child.offsetWidth);
        })
        split.revert();
    }

    /**
     * Öffnet ein neues browser Fenster mit einem HTML-Dokument
     * Das Dokument hat ein IMG als Inhalt mit der übergeben dataURL als SRC
     * Das erstellen des HTML-Dokuments ist nötig, da IE keine dataUrls öffnet
     * @memberOf v3sWbtPlayerApp:helper.service_v3sPrintService
     * @param {string} dataUrl
     */

    function openNewWindowWithImage(dataUrl, newWindow) {
        var html = '<!DOCTYPE html>' +
                            '<html>' +
                                '<head>' +
                                    '<meta charset="utf-8">' +
                                    '<title>Drucken</title>' +
                                '</head>' +
                                '<body>' +
                                    '<img src="' +dataUrl + '" />' +
                                '</body>' +
                            '</html>';
        newWindow.document.write(html);
        newWindow.document.close();
        newWindow.blur();
        newWindow.focus();

        $timeout(function () { newWindow.print(); }, 1000);
    }

    function print(element, format) {
        if (v3sBrowserInfoService.isViversaApp() || v3sBrowserInfoService.isResponsiveView()) {
            v3sLog.error(v3sI18nService.getText("general.printinapp"));
            return;
        }
        var data = createDataUrl(element, format);
        if (data.error) return;
        var html = '<!DOCTYPE html>' +
                               '<html>' +
                                   '<head>' +
                                       '<meta charset="utf-8">' +
                                       '<title>Drucken</title>' +
                                   '</head>' +
                                   '<body>' +
                                      '<h4 style="position: absolute;top: 50%;left: 50%;transform: translateX(-50%) translateY(-50%);">'+
                                      'Druckansicht wird vorbereitet...'+
                                      '</h4>' +
                                   '</body>' +
                               '</html>';
        var myWindow = window.open("", "Drucken");
        myWindow.document.write(html);
        myWindow.document.close();

        window.focus();
        openNewWindowWithImage(data.dataUrl, myWindow);
    }

    function save(element, format, filename) {
        if (v3sBrowserInfoService.isViversaApp() || v3sBrowserInfoService.isResponsiveView()) {
            v3sLog.error(v3sI18nService.getText("general.printinapp"));
            return;
        }
        var data = createDataUrl(element, format);
        if (data.error) return;


        //Dateinamen ".png" anhängen
        var indexOfExtension = filename.indexOf(".png");
        if (indexOfExtension == -1 || indexOfExtension !== filename.length -4) {
            filename += ".png";
        }
        if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(data.blob, filename);

        } else {
            var a = angular.element("<a download></a>");
            a.attr({
                "download": filename,
                "href": data.dataUrl
            });
            angular.element(element).find("v3s-document").append(a);
            a[0].click();
        }
    }

    return {

        print: print,
        save : save
    }
}]);